/**
 * action-costs — Constantes partagées client + serveur pour le système de points.
 *
 * Ce fichier n'a AUCUNE dépendance browser/serveur (pas de localStorage, pas de Supabase).
 * Il peut être importé depuis fetch-utils.ts (client) ET depuis auth-utils.ts (serveur).
 */

export type Plan = 'free' | 'mini' | 'premium';

export type ActionType =
  | 'aiAnalysis'
  | 'compare'
  | 'optimize'
  | 'coverLetter'
  | 'exportPdf'
  | 'exportDocx'
  | 'exportJson'
  | 'print';

export const ACTION_COSTS: Record<ActionType, number> = {
  aiAnalysis: 3,
  compare: 4,
  optimize: 5,
  coverLetter: 8,
  exportPdf: 5,
  exportDocx: 1,
  exportJson: 0,
  print: 0,
};

export const PLAN_MONTHLY_BUDGET: Record<Exclude<Plan, 'premium'>, number> = {
  free: 30,
  mini: 300,
};

/**
 * Mapping (route, action) → ActionType pour le serveur.
 * Les routes avec coût 0 (parse, models) ne sont pas dans cette map.
 */
export function routeToActionType(route: string, action?: string): ActionType | null {
  if (route === 'analyze') return 'aiAnalysis';
  if (route === 'compare') return 'compare';
  if (route === 'structure') return 'aiAnalysis';
  if (route === 'ats-optimize') {
    if (action === 'coverLetter') return 'coverLetter';
    // generate, optimize, translate — tous au coût optimize
    return 'optimize';
  }
  // parse, models → gratuit
  return null;
}

// ── Hard storage limits per plan (single source of truth for server + client) ──
export interface PlanStorageLimits {
  cvVersionsMax: number | null; // null = unlimited
  jobOffersMax: number | null;
}

export const PLAN_STORAGE_LIMITS: Record<Plan, PlanStorageLimits> = {
  free:    { cvVersionsMax: 3,    jobOffersMax: 5    },
  mini:    { cvVersionsMax: 10,   jobOffersMax: 20   },
  premium: { cvVersionsMax: null, jobOffersMax: null },
};
